import {Component} from 'react';
import AddCardModal from "../modals/AddCardModal";
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import DeleteCardConfirmModal from "../modals/DeleteCardConfirmModal";
import FastCreditModal from "../modals/FastCreditModal";
import Badge from 'react-bootstrap/lib/Badge';
import Button from 'react-bootstrap/lib/Button';
import CardSub from "../subcomponents/CardSub";
import AzureTable from "../AzureTable";
import LoadingModal from "../modals/LoadingModal";
import DeleteDialog from "../../utils/modals/higher/DeleteDialog";
import RecipeScreen from "../screens/RecipeScreen";

const GET_CARDS_URL = "https://qibipay.azurewebsites.net/api/GetRecipeList";
const REMOVE_RECIPE_ENDPOINT = "https://qibipay.azurewebsites.net/api/RecipeRemove"

class RecipesTab extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - logout
             - globalConfig
        */
        super(props);

        this.state = {
            addRecipeOpen: false,
            addRecipeId: null,

            loading: true
        };

    }

    render() {
        if(this.state.addRecipeOpen) {
            return (
                <RecipeScreen access_code={this.props.access_code} logout={this.props.logout} currency={this.props.currency}
                                recipeId={this.state.addRecipeId} onClose={() => {
                                    this.setState({
                                        addRecipeOpen: false,
                                        addRecipeId: null
                                    });
                }}/>
            );
        }
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-receipt"></i> Recipes <a href="javascript:void(0);" style={{
                                fontSize: "15px"
                            }} onClick={() => {
                                this.tableRef.resetTable();
                            }}><i className="fa fa-sync"></i></a></h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addRecipeOpen: true, addRecipeId: null})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Recipe
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <DeleteDialog access_code={this.props.access_code}
                              logout={this.props.logout}
                              url={REMOVE_RECIPE_ENDPOINT}
                              questionText="Do you really want to remove this recipe?"
                              questionTitle="Remove recipe"
                              successTitle="Remove success"
                              successText="Recipe has been successfully removed!"
                              failedTitle="Remove failed"
                              failedText="Error during recipe removal!"
                              loadingTitle="Removing recipe..."
                              sendParams={["recipeId"]}
                              onSuccess={() => this.tableRef.resetTable()}
                              dialogRef={ref => this.dialogRef = ref}/>

                <LoadingModal title="Loading..."
                            text="Loading recipes data..."
                            open={this.state.loading}/>

                <div className="container-fluid">
                    <AzureTable
                        logout={this.props.logout}
                        access_code={this.props.access_code}
                        onLoad={() => {
                            this.setState({
                                loading: false
                            });
                        }}
                        tableRef={(ref) => {
                            this.tableRef = ref;
                        }}
                        functionUrl={GET_CARDS_URL}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete') return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addRecipeOpen: true,
                                        addRecipeId: rowInfo.original.id
                                    });
                                }
                            };
                            return {};
                        }}
                        columns={[
                            {
                                Header: "ID",
                                accessor: "id",
                                filterable: true,
                                sortable: true,
                            },
                            {
                                Header: "Name",
                                accessor: "name",
                                sortable: true,
                                filterable: true
                            },
                            {
                                Header: "Description",
                                accessor: "description",
                                sortable: false,
                                filterable: false
                            },
                            {
                                Header: "Username",
                                accessor: "username",
                                sortable: false,
                                filterable: true,
                                width: 200,
                                notUseWhenNotPresent: true
                            }
                        ]}
                        filterable
                        defaultPageSize={10}
                        className="-striped -highlight"
                        pageSize={10}
                    />
                </div>
            </div>
        );
    }
}

export default RecipesTab;